{
    "nmb": "ascending",
    "mnmb": "ascending",
    "R": "descending",
    "R_spearman": "descending",
    "RMSE": "ascending",
    "fge": "ascending",
    "mb": "ascending",
    "rms": "ascending",
    "R_spatial_mean": "descending",
    "R_temporal_median": "descending"
}